"use strict";
/**
 * @file 后端接口返回的错误码处理
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCode = void 0;
/**
 * 将后端的错误码处理成前端能够识别的错误码
 * 如果输入的错误码为 8 位数字、错误码第一位数字是 2，且前端错误码中包含该错误码，那么返回去掉 2 之后的 7 位数字
 * 如果输入的错误码不符合上述条件，则返回原错误码
 * @param code 错误码
 */
function parseCode(code, existCodes) {
    try {
        var codeStringify = '' + code;
        var existCodesType = Object.prototype.toString.call(existCodes);
        var existCodesList = existCodesType === '[object Object]'
            ? Object.keys(existCodes)
            : existCodesType === '[object Array]'
                ? existCodes.map(function (code) { return '' + code; })
                : [];
        if (/^2\d{7}$/.test(codeStringify)) {
            var codeLeft = codeStringify.substring(1);
            if (existCodesList.indexOf(codeLeft) > -1) {
                return +codeLeft;
            }
        }
        return code;
    }
    catch (error) {
        return code;
    }
}
exports.parseCode = parseCode;
